import { useSettings } from "@/lib/settings";
import { Smartphone, QrCode } from "lucide-react";

export default function MobileAppSection() {
  const { settings } = useSettings();
  const app = settings?.mobile_app;
  if (!app || !app.enabled) return null;

  return (
    <section className="py-24 bg-gradient-to-br from-neutral-50 to-sky-50 overflow-hidden" data-testid="mobile-app-section">
      <div className="container-eq grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="label-eq text-sky-500 mb-3">Mobile App</div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold tracking-tight leading-tight" data-testid="mobile-app-heading">
            {app.heading}
          </h2>
          <p className="mt-4 text-neutral-600 leading-relaxed max-w-lg">{app.subheading}</p>

          <div className="mt-8 flex flex-wrap gap-3">
            {app.google_play_url && (
              <a href={app.google_play_url} target="_blank" rel="noreferrer" data-testid="mobile-app-google-play" className="inline-block transition-transform hover:-translate-y-1">
                {app.google_play_badge ? (
                  <img src={app.google_play_badge} alt="Get it on Google Play" className="h-14" />
                ) : (
                  <div className="bg-black text-white px-5 py-3 rounded-xl flex items-center gap-3">
                    <Smartphone className="w-6 h-6" />
                    <div><div className="text-[10px]">GET IT ON</div><div className="font-bold">Google Play</div></div>
                  </div>
                )}
              </a>
            )}
            {app.apple_store_url && (
              <a href={app.apple_store_url} target="_blank" rel="noreferrer" data-testid="mobile-app-apple-store" className="inline-block transition-transform hover:-translate-y-1">
                {app.apple_store_badge ? (
                  <img src={app.apple_store_badge} alt="Download on the App Store" className="h-14" />
                ) : (
                  <div className="bg-black text-white px-5 py-3 rounded-xl flex items-center gap-3">
                    <Smartphone className="w-6 h-6" />
                    <div><div className="text-[10px]">Download on the</div><div className="font-bold">App Store</div></div>
                  </div>
                )}
              </a>
            )}
          </div>

          {app.qr_image && (
            <div className="mt-8 inline-flex items-center gap-4 p-4 bg-white rounded-2xl border border-neutral-200">
              <img src={app.qr_image} alt="QR" className="w-20 h-20 rounded-lg" />
              <div>
                <div className="label-eq text-neutral-500">Scan to download</div>
                <div className="text-sm font-semibold mt-1">Point your camera at the QR code</div>
              </div>
            </div>
          )}
        </div>
        <div className="relative flex justify-center">
          {app.mockup_image && (
            <div className="relative">
              <div className="absolute inset-0 bg-sky-200 rounded-[3rem] blur-2xl opacity-40"></div>
              <img src={app.mockup_image} alt="App preview" className="relative rounded-3xl max-h-[540px] object-cover shadow-2xl" data-testid="mobile-app-mockup" />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
